export const scrollToSection = (sectionId: string) => {
  // Add a small delay to ensure the DOM is ready
  setTimeout(() => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80; // Height of the fixed navbar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - navbarHeight;

      // Use scrollIntoView as a fallback
      try {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      } catch (error) {
        // Fallback for browsers that don't support smooth scrolling
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      console.warn(`Section with id "${sectionId}" not found`);
    }
  }, 100);
}; 